/* MkaeSense sun globes: city view (December solstice daylight) and all-places view. Loads its libraries only when a globe scrolls into view. */
(function () {
  var CDN = 'https://cdn.jsdelivr.net/npm/';
  var LIBS = ['d3-array@3.2.4/dist/d3-array.min.js', 'd3-geo@3.1.1/dist/d3-geo.min.js', 'topojson-client@3.1.0/dist/topojson-client.min.js'];
  var ready = null, land = null;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function load(src) {
    return new Promise(function (res, rej) { var s = document.createElement('script'); s.src = CDN + src; s.onload = res; s.onerror = rej; document.head.appendChild(s); });
  }
  function boot() {
    if (!ready) {
      ready = LIBS.reduce(function (p, s) { return p.then(function () { return load(s); }); }, Promise.resolve())
        .then(function () { return fetch(CDN + 'world-atlas@2.0.2/land-110m.json'); })
        .then(function (r) { return r.json(); })
        .then(function (t) { land = topojson.feature(t, t.objects.land); });
    }
    return ready;
  }
  function col(v) { return v < 1 ? '#34548a' : v < 2 ? '#5878ad' : v < 3.5 ? '#a39a80' : v < 5 ? '#dcaa55' : '#f6bd5c'; }
  function wrap(x) { return ((x + 540) % 360) - 180; }

  function globe(el) {
    var cv = document.createElement('canvas');
    el.appendChild(cv);
    var ctx = cv.getContext('2d');
    var lat = parseFloat(el.dataset.lat), lon = parseFloat(el.dataset.lon);
    var pts = null, tip = null;
    if (el.dataset.src) {
      var node = document.getElementById(el.dataset.src);
      pts = node ? JSON.parse(node.textContent) : [];
      tip = document.createElement('div'); tip.className = 'sk-gtip'; tip.hidden = true; el.appendChild(tip);
      if (isNaN(lat)) { lat = 42; lon = -92; }
    }
    var proj = d3.geoOrthographic().clipAngle(90).precision(0.4);
    var path = d3.geoPath(proj, ctx);
    var grat = d3.geoGraticule10();
    var night = d3.geoCircle().center([wrap(lon + 180), 23.44]).radius(90)();
    var tropic = { type: 'LineString', coordinates: d3.range(-180, 181, 2).map(function (x) { return [x, -23.44]; }) };
    var tilt = -Math.max(-60, Math.min(60, lat)) * 0.8;
    var target = [-lon, tilt, 0];
    var rot = reduce ? target.slice() : [-lon + 80, tilt + 12, 0];
    var W = 0, dpr = 1, hover = null, queued = false;

    function size() {
      var w = el.clientWidth; if (!w) return;
      dpr = Math.min(2, window.devicePixelRatio || 1);
      cv.width = Math.round(w * dpr); cv.height = Math.round(w * dpr);
      cv.style.width = w + 'px'; cv.style.height = w + 'px';
      W = w; proj.translate([w / 2, w / 2]).scale(w / 2 - 2);
    }
    function visible(lo, la) { return d3.geoDistance([lo, la], [-rot[0], -rot[1]]) < 1.53; }
    function draw() {
      queued = false;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0); ctx.clearRect(0, 0, W, W); proj.rotate(rot);
      var g = ctx.createRadialGradient(W * 0.36, W * 0.3, W * 0.04, W / 2, W / 2, W / 2);
      g.addColorStop(0, '#171b24'); g.addColorStop(1, '#05060a');
      ctx.beginPath(); path({ type: 'Sphere' }); ctx.fillStyle = g; ctx.fill();
      ctx.beginPath(); path(grat); ctx.strokeStyle = 'rgba(255,255,255,.055)'; ctx.lineWidth = 1; ctx.stroke();
      ctx.beginPath(); path(land); ctx.fillStyle = '#252a35'; ctx.fill(); ctx.strokeStyle = 'rgba(255,255,255,.16)'; ctx.lineWidth = 0.6; ctx.stroke();
      if (!pts) {
        ctx.beginPath(); path(night); ctx.fillStyle = 'rgba(0,0,0,.58)'; ctx.fill();
        ctx.save(); ctx.setLineDash([3, 4]); ctx.beginPath(); path(tropic); ctx.strokeStyle = 'rgba(242,182,90,.6)'; ctx.lineWidth = 1; ctx.stroke(); ctx.restore();
      }
      ctx.beginPath(); path({ type: 'Sphere' }); ctx.strokeStyle = 'rgba(255,255,255,.18)'; ctx.lineWidth = 1; ctx.stroke();
      if (pts) {
        for (var i = 0; i < pts.length; i++) {
          var p = pts[i]; if (!visible(p[1], p[0])) continue;
          var xy = proj([p[1], p[0]]);
          ctx.beginPath(); ctx.arc(xy[0], xy[1], p === hover ? 5 : 2.8, 0, 6.2832); ctx.fillStyle = col(p[2]); ctx.fill();
          if (p === hover) { ctx.strokeStyle = '#fff'; ctx.lineWidth = 1.5; ctx.stroke(); }
        }
      } else if (visible(lon, lat)) {
        var c = proj([lon, lat]);
        ctx.beginPath(); ctx.arc(c[0], c[1], 10, 0, 6.2832); ctx.strokeStyle = 'rgba(242,182,90,.45)'; ctx.lineWidth = 1.5; ctx.stroke();
        ctx.beginPath(); ctx.arc(c[0], c[1], 4.2, 0, 6.2832); ctx.fillStyle = '#f2b65a'; ctx.fill();
      }
    }
    function req() { if (!queued) { queued = true; requestAnimationFrame(draw); } }

    function intro() {
      if (reduce) { draw(); return; }
      var from = rot.slice(), t0 = null, dur = 1600;
      function step(t) {
        if (t0 === null) t0 = t;
        var k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 3);
        rot = [from[0] + (target[0] - from[0]) * e, from[1] + (target[1] - from[1]) * e, 0];
        draw();
        if (k < 1 && !dragging) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    var dragging = false, sx = 0, sy = 0, r0 = null, moved = 0;
    cv.addEventListener('pointerdown', function (e) { dragging = true; moved = 0; sx = e.clientX; sy = e.clientY; r0 = rot.slice(); cv.setPointerCapture(e.pointerId); cv.classList.add('is-drag'); });
    cv.addEventListener('pointermove', function (e) {
      if (dragging) {
        var dx = e.clientX - sx, dy = e.clientY - sy; moved = Math.max(moved, Math.abs(dx) + Math.abs(dy));
        var k = 180 / W;
        rot = [r0[0] + dx * k, Math.max(-80, Math.min(80, r0[1] - dy * k)), 0];
        if (tip) tip.hidden = true;
        req(); return;
      }
      if (!pts) return;
      var b = cv.getBoundingClientRect(), mx = e.clientX - b.left, my = e.clientY - b.top, best = null, bd = 144;
      for (var i = 0; i < pts.length; i++) {
        var p = pts[i]; if (!visible(p[1], p[0])) continue;
        var xy = proj([p[1], p[0]]), d = (xy[0] - mx) * (xy[0] - mx) + (xy[1] - my) * (xy[1] - my);
        if (d < bd) { bd = d; best = p; }
      }
      if (best !== hover) { hover = best; req(); }
      if (best) {
        var q = proj([best[1], best[0]]);
        tip.innerHTML = '<b></b><span></span>';
        tip.firstChild.textContent = best[3];
        tip.lastChild.textContent = best[2].toFixed(2) + ' h in its dimmest month';
        tip.style.left = q[0] + 'px'; tip.style.top = q[1] + 'px'; tip.hidden = false; cv.style.cursor = 'pointer';
      } else { tip.hidden = true; cv.style.cursor = ''; }
    });
    function end() { dragging = false; cv.classList.remove('is-drag'); }
    cv.addEventListener('pointerup', function () { var click = moved < 5; end(); if (click && hover) location.href = '/blogs/sun-hours/' + hover[4]; });
    cv.addEventListener('pointercancel', end);
    cv.addEventListener('pointerleave', function () { if (!dragging && hover) { hover = null; if (tip) tip.hidden = true; req(); } });

    size();
    if (window.ResizeObserver) new ResizeObserver(function () { var w = el.clientWidth; if (w && w !== W) { size(); draw(); } }).observe(el);
    el.classList.add('is-ready');
    intro();
  }

  function start() {
    var els = document.querySelectorAll('[data-sk-globe]');
    if (!els.length) return;
    var go = function (el) { boot().then(function () { globe(el); }).catch(function () { el.classList.add('is-failed'); }); };
    if (!('IntersectionObserver' in window)) { els.forEach(go); return; }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { if (en.isIntersecting) { io.unobserve(en.target); go(en.target); } });
    }, { rootMargin: '200px' });
    els.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();